export const isWeb = process.env.VUE_APP_DEVICE === 'web'
export const isMobile = process.env.VUE_APP_DEVICE === 'mobile'
